// extracted by mini-css-extract-plugin
export default {"wrapper":"RulesPageTable_wrapper__yroCc"};